export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: data?.header?.primary_heading || "",
      secondary_heading: data?.header?.secondary_heading || "",
      description: data?.header?.description || "",
      primary_cta: data?.header?.primary_cta || { label: "", redirect_link: "" },
      secondary_cta: data?.header?.secondary_cta || { label: "", redirect_link: "" },
    },
     courses: {
      selectedCourses: data?.courses?.selectedCourses || [{ course: "", keyword: "" }],
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: values?.header?.primary_heading || "",
      secondary_heading: values?.header?.secondary_heading || "",
      description: values?.header?.description || "",
      primary_cta: values?.header?.primary_cta || { label: "", redirect_link: "" },
      secondary_cta: values?.header?.secondary_cta || { label: "", redirect_link: "" },
    },
    // courses: {
    //   selectedCourses: values?.courses?.selectedCourses || [],
    //    keywords: values?.courses?.keywords || [],
    // },

    courses: {
      selectedCourses: values?.courses?.selectedCourses || [{ course: "", keyword: "" }],
    },
  };
};
